import { Component, Input } from '@angular/core';

@Component({
    selector: 'aa-dash-explicit-appli-container',
    templateUrl: './dash-explicit-appli-container.component.html',
    styleUrls: [
        './dash-explicit-appli-container.component.scss'
    ],
    standalone: false
})
export class DashExplicitAppliContainerComponent
{
    @Input() iconClass: string;
    @Input() title: string;
}
